module.exports = __webpack_public_path__ + "static/media/notification-img.8508104d.png";